import './page-video/sl-zoom'
import './page-video/full-sl-img'


// WEBPACK FOOTER //
// ./src/js/pages/page-video.js